import * as React from 'react';

const CreateHeader: React.FC = ({ children }) => <div className="create-header">{children}</div>;

export default CreateHeader;
